import { graphqlClient } from '../../graphql/graphql'
import { VALIDATE_INSTALLMENTS, CREATE_ORDER, CREATE_FREE_ORDER, EXECUTE_CARD_PAYMENT } from '../../graphql/mutations/order'
import { CHECKOUT_INFORMATION } from '../../graphql/queries/order'

/**
 * Consultar información del evento para mostrarla en el checkout
 * @param {String} id Identificardor del evento
 */
export const fetchCheckoutInformation = async ({ commit }, id) => {
    let { data: { checkoutInformation } } = await graphqlClient.query({
        query: CHECKOUT_INFORMATION,
        variables: { id },
        fetchPolicy: 'no-cache'
    })
    commit('setCheckoutInformation', checkoutInformation)
}

/**
 * Validar que la tarjeta tenga meses sin intereses
 */
export const validateInstallments = async ({ commit }, validationData) => {

    let { data: { validateInstallments: { availablePlans, intentId, clientSecret } } } = await graphqlClient.mutate({
        mutation: VALIDATE_INSTALLMENTS(validationData)
    })

    commit('setCardPaymentInformation', { intentId, clientSecret })
    return availablePlans
}

/**
 * Crear crear un registro de los asistentes a un evento
 * (Solo se manda a llamar cuando el asistente adquiere boletos con costo)
 * (El registro se muestra en últimas transacciones y lista de asistentes una vez que se completa el registro con todo y pago)
 * @param {Object} order Objecto de orden generado en el checkout
 */
export const createOrder = async ({ commit }, order) => {
    let { data: { createOrder: { id } } } = await graphqlClient.mutate({
        mutation: CREATE_ORDER(order)
    })
    return id
}

/**
 * Crear crear un registro de los asistentes a un evento
 * (Solo se manda a llamar cuando el evento es gratuito y el asistente adquirió un boleto con cupón o cortesía)
 * (El registro se muestra en últimas transacciones y lista de asistentes una vez que se completa el registro)
 * @param {Object} order Objecto de orden generado en el checkout
 */
export const createFreeOrder = async ({ commit }, order) => {
    let { data: { createFreeOrder: { id } } } = await graphqlClient.mutate({
        mutation: CREATE_FREE_ORDER(order)
    })
    return id
}

/**
 * Función para ejecutar pago con tarjeta
 * @param {Objecto} cardInformation Información de la tarjeta.
 */
export const executeCardPayment = async ({ commit }, cardInformation) => {
    let response = await graphqlClient.mutate({
        mutation: EXECUTE_CARD_PAYMENT(cardInformation)
    });
    return response;
}
